import { render } from "./NoPermissionComponent.vue?vue&type=template&id=3ac6c2e3"
import script from "./NoPermissionComponent.vue?vue&type=script&lang=js"
export * from "./NoPermissionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__